const Keyboard = () => import('@/views/wiki/Keyboard');
const Commands = () => import('@/views/wiki/Commands');
const CrimeMinigames = () => import('@/views/wiki/CrimeMinigames');

const routes = [
  {
    path: 'keyboard',
    name: 'Keyboard',
    component: Keyboard,
  },
  {
    path: 'commands',
    name: 'Commands',
    component: Commands,
  },
  {
    path: 'crimeminigames',
    name: 'CrimeMinigames',
    component: CrimeMinigames,
  },
];

export default routes;
